import React, {useEffect, useState} from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import { Div } from 'styles';
import _ from 'lodash';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

export function NewChart({chartData}) {
  const [labels, setLabels] = useState([]);
  const [factoryTempData, setFactoryTempData] = useState([]);
  const [factoryHumData, setFactoryHumData] = useState([]);

  const getHour = (time) => {
    const vals = _.trim(time).split('  ');
    if(vals.length > 1){
      return vals[1].split(':')[0] + '시';
    }
    return '-';
  }
  useEffect(() => {
    const chartLabels = [];
    const factoryTempList = [];
    const factoryHumList = [];
    _.each(chartData, (data) => {
      chartLabels.push(getHour(data.time));
      factoryTempList.push(data.factory_temp);
      factoryHumList.push(data.factory_hum);
    });

    setLabels(chartLabels);
    setFactoryTempData(factoryTempList);
    setFactoryHumData(factoryHumList);

  }, [chartData]);


  const options = {
    responsive: true,
    maintainAspectRatio: false,
    align: 'center',
    plugins: {
      legend: {
        position: 'bottom',
        align: 'center',
        labels: {
          usePointStyle: true,
          pointStyle: 'circle',
          boxWidth: 10,
          boxHeight: 10,
          boxAlign: 'start',
          padding: 24,
          color: '#282D32',
          font: {
            size: 14,
            family: 'Pretendard',
          },
        },
        padding: 24,
      },
      title: {
        display: false,
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        border: {
          display: false,
        },
        ticks: {
          padding: 10,
          font: {
            family: 'Pretendard',
            size: 12,
            weight: '500',
            lineHeight: 1.5,
          },
          color: 'rgb(23, 23, 23, 0.7)',
        },
        grid: {
          drawTicks: false,
          drawBorder: false,
        },
      },
      x: {
        grid: {
          display: false,
          drawBorder: false,
        },
        ticks: {
          font: { family: 'Pretendard', size: 12, weight: '500', lineHeight: 1.5 },
          color: 'rgb(23, 23, 23, 0.7)',
        },
      },
    },
  };

  const data = {
    labels,
    datasets: [
      {
        label: '온도',
        data: factoryTempData,
        backgroundColor: '#FFA58A',
        borderColor: '#FFA58A',
        hoverBorderColor: '#FFA58A',
        barPercentage: 0.6,
        categoryPercentage: 0.4,
        borderRadius: { topLeft: 6, topRight: 6 },
      },
      {
        label: '습도',
        data: factoryHumData,
        backgroundColor: '#F5E292',
        borderColor: '#F5E292',
        hoverBorderColor: '#F5E292',
        barPercentage: 0.6,
        categoryPercentage: 0.4,
        borderRadius: { topLeft: 6, topRight: 6 },
      },
    ],
  };

  return (
    <Div $width="100%" $height={395}>
      <Bar options={options} data={data} />
    </Div>
  );
}
